<script lang="ts">
    import sortBy from 'lodash/sortBy';

    import { taskMap } from '@/data/tasks';
    import { QuestStatus } from '@/enums/quest-status';
    import { uiIcons } from '@/shared/icons/ui';
    import { settingsState } from '@/shared/state/settings.svelte';
    import { userState } from '@/user-home/state/user';
    import type { CharacterProps } from '@/types/props';

    import IconifyWrapper from '@/shared/components/images/IconifyWrapper.svelte';
    import QuestStatusIcon from '@/shared/components/icons/QuestStatusIcon.svelte';

    type Props = CharacterProps & {
        fullTaskName: string;
        taskName: string;
    };
    let { character, fullTaskName, taskName }: Props = $props();

    let task = $derived(taskMap[taskName] || settingsState.customTaskMap[taskName]);
    let charTask = $derived(userState.activeViewTasks[character.id]?.[fullTaskName]);

    let inProgress = $derived(
        charTask &&
            Object.values(charTask.chores).every((charChore) => {
                const oof = task.chores.find((chore) => chore?.key === charChore.key);
                return charChore.skipped || oof?.alwaysStarted === true || charChore?.status > 0;
            })
    );

    let sortedChores = $derived(
        task.sortByExpiry && charTask && sortBy(charTask.chores, (chore) => chore.expiresAt)
    );
</script>

<style lang="scss">
    td {
        --width: $width-weekly-quest;

        text-align: center;
        word-spacing: -0.2ch;
    }
    .ready {
        box-shadow: inset 0 0 0 1px var(--color-shrug);
    }
</style>

{#if charTask?.countTotal > 0 && Object.keys(charTask?.chores || {}).length > 0}
    {@const notStarted = charTask.countTotal - charTask.countCompleted - charTask.countStarted}
    <td
        class="b-l tooltip-task"
        class:status-fail={!inProgress && notStarted > 0}
        class:status-shrug={inProgress ||
            (notStarted === 0 && charTask.countCompleted < charTask.countTotal)}
        class:status-success={charTask.status === QuestStatus.Completed}
        class:ready={charTask.anyReady}
        data-character-id={character.id}
        data-full-task-name={fullTaskName}
    >
        {#if Object.values(charTask.chores).filter((chore) => !chore.skipped).length === 1}
            {#if charTask.status === QuestStatus.Completed}
                <IconifyWrapper icon={uiIcons.starFull} />
            {:else if charTask.countCompleted === charTask.countTotal}
                <IconifyWrapper icon={uiIcons.question} scale="0.75" />
            {:else if !inProgress}
                <IconifyWrapper icon={uiIcons.starEmpty} />
            {:else}
                {charTask.countCompleted} / {charTask.countTotal}
            {/if}
        {:else if charTask.countTotal === 1 && charTask.status !== QuestStatus.InProgress}
            {#if charTask.countCompleted === 0}
                Get!
            {:else}
                Done
            {/if}
        {:else if task.showRowStars}
            {#each sortedChores as sortedChore}
                <QuestStatusIcon status={sortedChore.status} useStatusColors={true} />
            {/each}
        {:else}
            {charTask.countCompleted} / {charTask.countTotal}
        {/if}
    </td>
{:else}
    <td class="b-l status-warn">---</td>
{/if}
